// Official Danish RAADS-R (Ritvo Autism Asperger Diagnostic Scale-Revised) Data

export const OPTIONS = [
  'Sandt nu og da jeg var ung',
  'Kun sandt nu',
  'Kun sandt, da jeg var ung',
  'Aldrig sandt'
];

export const REVERSE_QUESTIONS = [1, 6, 11, 18, 23, 26, 33, 37, 43, 47, 48, 53, 58, 62, 68, 72, 77];

export const SUBSCALES = {
  social: {
    key: 'social',
    title: 'Social forståelse og relationer',
    questions: [1, 3, 5, 6, 11, 12, 14, 15, 17, 18, 20, 21, 22, 23, 25, 26, 28, 31, 37, 38, 39, 43, 44, 45, 47, 48, 53, 54, 55, 58, 61, 64, 68, 69, 72, 76, 77, 79],
    maxScore: 38 * 3
  },
  language: {
    key: 'language',
    title: 'Sprog',
    questions: [2, 4, 7, 24, 27, 32, 33, 35, 49, 56, 60, 62, 66, 78, 80],
    maxScore: 15 * 3
  },
  interests: {
    key: 'interests',
    title: 'Afgrænsede interesser',
    questions: [8, 9, 13, 30, 40, 41, 50, 52, 63, 70, 75],
    maxScore: 11 * 3
  },
  sensory: {
    key: 'sensory',
    title: 'Sensorik og motorik',
    questions: [10, 16, 19, 29, 34, 36, 42, 46, 51, 57, 59, 65, 67, 71, 73, 74],
    maxScore: 16 * 3
  }
};

export const RAADS_R_QUESTIONS = [
  { id: 1, text: 'Jeg finder det kortere og lettere at tale med personer, som har samme specielle interesser som mig selv, end med andre.' },
  { id: 2, text: 'Andre siger, at jeg taler som en bog eller på en \'mærkelig\' måde.' },
  { id: 3, text: 'Jeg ved ikke, hvad der er passende at gøre eller sige i sociale situationer.' },
  { id: 4, text: 'Nogle gange tager jeg ting for bogstaveligt og forstår ikke, hvad folk mener.' },
  { id: 5, text: 'Det er svært for mig at forstå, hvornår det er min tur til at tale i en samtale.' },
  { id: 6, text: 'Jeg er god til at mærke, hvad andre føler, når de er kede af det eller glade.' },
  { id: 7, text: 'Det er svært for mig at variere mit tonefald i forhold til situationen.' },
  { id: 8, text: 'Jeg samler på informationer om bestemte emner og ved meget mere om dem end de fleste andre.' },
  { id: 9, text: 'Jeg bliver meget optaget af detaljer i mine interesser og glemmer alt andet omkring mig.' },
  { id: 10, text: 'Jeg oplever støj, skarpt lys eller bestemte tekstiler som meget ubehagelige eller overvældende.' },
  { id: 11, text: 'Jeg har let ved at skaffe mig nye venner.' },
  { id: 12, text: 'Jeg føler mig ofte som en udenforstående i sociale grupper.' },
  { id: 13, text: 'Hvis mine daglige rutiner bliver brudt, bliver jeg meget forstyrret eller utryg.' },
  { id: 14, text: 'Jeg foretrækker at lave ting alene frem for sammen med andre.' },
  { id: 15, text: 'Jeg finder det vanskeligt at indgå i smalltalk eller uforpligtende samtaler.' },
  { id: 16, text: 'Jeg har usædvanlige eller gentagne kropsbevægelser (som f.eks. at vippe, spænde eller fipse med fingrene).' },
  { id: 17, text: 'Jeg har svært ved at forstå, hvorfor andre reagerer, som de gør, i følelsesmæssige situationer.' },
  { id: 18, text: 'Jeg forstår let humor, ironi og drillerier.' },
  { id: 19, text: 'Jeg er overfølsom eller underfølsom over for smerte, kulde eller varme.' },
  { id: 20, text: 'Det kræver meget energi for mig at opretholde øjenkontakt under en samtale.' },
  { id: 21, text: 'Jeg har altid haft svært ved at forstå sociale spilleregler og uskrevne love.' },
  { id: 22, text: 'Når jeg er sammen med andre, bruger jeg bevidst strategier eller analyser for at opføre mig \'normalt\'.' },
  { id: 23, text: 'Jeg har let ved at se tingene fra en anden persons synsvinkel.' },
  { id: 24, text: 'Folk har fortalt mig, at jeg taler for højt, for lavt eller for fladt.' },
  { id: 25, text: 'Jeg oplever ofte at blive misforstået af andre i sociale sammenhænge.' },
  { id: 26, text: 'Jeg trives godt med uforudsete ændringer i hverdagen.' },
  { id: 27, text: 'Jeg har svært ved at forstå, hvornår en samtale er slut eller hvordan man afrunder den.' },
  { id: 28, text: 'Jeg har svært ved at opretholde venskaber over længere tid.' },
  { id: 29, text: 'Jeg foretrækker bestemte konsistenser eller smage i mad, og undgår andre helt.' },
  { id: 30, text: 'Jeg bruger meget tid på at organisere, sortere eller systematisere ting.' },
  { id: 31, text: 'Det er vanskeligt for mig at deltage i gruppesamtaler med flere personer.' },
  { id: 32, text: 'Jeg taler ofte om mine egne interesser, selvom andre ikke virker interesserede.' },
  { id: 33, text: 'Jeg har let ved at tilpasse mig nye sociale miljøer.' },
  { id: 34, text: 'Jeg har usædvanlig god hørelse eller bliver let forstyrret af baggrundsstøj.' },
  { id: 35, text: 'Jeg bruger ofte bestemte ord eller sætninger igen og igen.' },
  { id: 36, text: 'Min kropskoordination eller finmotorik kan føles klodset eller akavet.' },
  { id: 37, text: 'Jeg føler mig tryg og tilpas i større forsamlinger og fester.' },
  { id: 38, text: 'Jeg har svært ved at regne ud, hvad andre mener ud fra deres ansigtsudtryk eller kropssprog.' },
  { id: 39, text: 'Jeg foretrækker at skrive eller kommunikere tekstuelt frem for at tale i telefon.' },
  { id: 40, text: 'Jeg har dybe og langvarige særinteresser, som har fulgt mig i mange år.' },
  { id: 41, text: 'Jeg bliver meget frustreret, hvis ting ikke står på deres vante pladser.' },
  { id: 42, text: 'Bestemte lyde eller mønstre kan fascinere mig i lang tid.' },
  { id: 43, text: 'Jeg er god til at læse mellem linjerne i hvad folk siger.' },
  { id: 44, text: 'Jeg har ofte oplevet at føle mig anderledes end mine jævnaldrende gennem opvæksten.' },
  { id: 45, text: 'Jeg oplever ofte social udmattelse efter at have været sammen med andre mennesker.' },
  { id: 46, text: 'Jeg reagerer stærkt på bestemte lugte, berøringer eller tøjmærker.' },
  { id: 47, text: 'Jeg er god til at lave spontane planer og improvisere.' },
  { id: 48, text: 'Jeg synes det er nemt at indlede en samtale med en fremmed.' },
  { id: 49, text: 'Jeg har svært ved at vide, hvornår folk er alvorlige, eller hvornår de spøger.' },
  { id: 50, text: 'Jeg interesserer mig mere for fakta, systemer og mønstre end for sociale forhold.' },
  { id: 51, text: 'Jeg bevæger mig eller går på en måde, som andre har bemærket som speciel.' },
  { id: 52, text: 'Jeg kan bruge timer på at fordybe mig i et emne uden at mærke tid og sted.' },
  { id: 53, text: 'Jeg føler mig hurtigt hjemme i et rum med mange nye mennesker.' },
  { id: 54, text: 'Jeg synes, det er hårdt arbejde at deltage i familiesammenkomster eller sociale arrangementer.' },
  { id: 55, text: 'Jeg forstår ikke altid, hvorfor andre bliver kede af det over ting, som jeg finder uansvarlige eller ligegyldige.' },
  { id: 56, text: 'Jeg genfortæller ofte historier med meget præcise og udtømmende detaljer.' },
  { id: 57, text: 'Jeg reagerer anderledes på berøring end de fleste andre.' },
  { id: 58, text: 'Jeg finder det let at trøste en anden person, der er kriseramt eller ked af det.' },
  { id: 59, text: 'Jeg har tendens til at lave vuggende eller rytmiske bevægelser, når jeg slapper af eller er stresset.' },
  { id: 60, text: 'Jeg har svært ved at opfatte antydninger eller underforstået kritik.' },
  { id: 61, text: 'Jeg holder af at være sammen med andre, men har brug for meget tid for mig selv bagefter.' },
  { id: 62, text: 'Jeg forstår spontant sociale koder uden at skulle tænke over dem.' },
  { id: 63, text: 'Jeg har bestemte ritualer, som jeg skal igennem hver dag for at føle ro.' },
  { id: 64, text: 'Jeg undgår ofte arrangementer, fordi der er for mange mennesker eller indtryk.' },
  { id: 65, text: 'Jeg bemærker små detaljer, mønstre eller lyde, som andre slet ikke lægger mærke til.' },
  { id: 66, text: 'Jeg har svært ved at forklare mine følelser med ord.' },
  { id: 67, text: 'Jeg finder trøst i at gentage de samme handlinger eller sætninger, når jeg er utryg.' },
  { id: 68, text: 'Jeg oplever det som ubesværet at skifte fra én opgave til en helt anden.' },
  { id: 69, text: 'Jeg føler mig mere knyttet til genstande, emner eller dyr end til de fleste mennesker.' },
  { id: 70, text: 'Jeg har et stærkt behov for at færdiggøre ting præcis som planlagt.' },
  { id: 71, text: 'Jeg finder visse synsindtryk (som f.eks. lysreflekser eller mønstre) fascinerende.' },
  { id: 72, text: 'Jeg lægger nemt mærke til, når en person ønsker at afslutte en samtale.' },
  { id: 73, text: 'Jeg er følsom over for forandringer i temperatur eller vejrforhold.' },
  { id: 74, text: 'Jeg kan have svært ved at vurdere min krops placering i rummet (f.eks. støde ind i ting).' },
  { id: 75, text: 'Jeg kan tale i lang tid om mit yndlingsemne uden at opdage, at tilhøreren er træt af at lytte.' },
  { id: 76, text: 'Jeg har ofte svært ved at vide, hvordan jeg skal reagere, når folk viser stærke følelser.' },
  { id: 77, text: 'Jeg føler mig tryg ved at udtrykke mine følelser over for andre.' },
  { id: 78, text: 'Jeg tager ordsprogsbetydninger eller talemåder mere bogstaveligt end tilsigtet.' },
  { id: 79, text: 'Jeg foretrækker forudsigelige sociale rammer med klare roller og regler.' },
  { id: 80, text: 'Jeg har svært ved at skifte samtalemne, hvis jeg ikke er færdig med det forrige.' }
];

export function calculateRaadsRScore(answers) {
  // answers is an object mapping questionId (1-80) to selectedOptionIndex (0-3)
  // Check if all 80 questions are answered
  let isComplete = true;
  for (let i = 1; i <= 80; i++) {
    if (answers[i] === undefined || answers[i] === null) {
      isComplete = false;
      break;
    }
  }

  let totalScore = 0;
  const subscaleScores = {
    social: 0,
    language: 0,
    interests: 0,
    sensory: 0
  };

  for (let i = 1; i <= 80; i++) {
    const optIdx = answers[i];
    if (optIdx === undefined || optIdx === null) continue;

    const isReverse = REVERSE_QUESTIONS.includes(i);
    const score = isReverse ? optIdx : (3 - optIdx);

    totalScore += score;

    if (SUBSCALES.social.questions.includes(i)) {
      subscaleScores.social += score;
    } else if (SUBSCALES.language.questions.includes(i)) {
      subscaleScores.language += score;
    } else if (SUBSCALES.interests.questions.includes(i)) {
      subscaleScores.interests += score;
    } else if (SUBSCALES.sensory.questions.includes(i)) {
      subscaleScores.sensory += score;
    }
  }

  return {
    isComplete,
    totalScore,
    subscaleScores,
    maxTotalScore: 240
  };
}
